import React, { memo } from 'react'
import Modal from 'Components/modal'

export interface IDeclareTextProps {
  show: boolean
  onHide: () => void
}

function DeclareText({ show, onHide }: IDeclareTextProps) {
  return (
    <>
      <Modal
        width={600}
        visible={show}
        onClose={onHide}
        title="个人信息保护声明"
        footer={(
          <button className="btnok" type="button" onClick={onHide}>
            我知道了
          </button>
        )}
      >
        <div className="agree-content">
          <p>用户个人信息保护法律声明</p>
          <br />
          <br />
          <p>
            北京空间变换科技有限公司（以下称“我们”或“空间变换”公司）非常重视用户信息的保护。您在使用我们的“懂车帝”软件时，我们可能会收集和使用您的相关信息。我们希望通过本声明向您说明，在使用我们的服务时，我们如何收集、使用、存储、保护这些信息。在使用“懂车帝”软件及服务或在相应页面填写个人信息前，请您务必仔细阅读本声明。您一旦选择使用我们的服务（包括但不限于主动在相应页面填写您的个人信息），即意味着您同意我们按照本声明收集、使用、储存您的相关信息。
          </p>
          <p>一、信息可能收集的范围与方式</p>
          <br />
          <p>
            1、我们提供服务时，可能会收集、储存和使用下列与您有关的信息，这些信息包括但不限于：
          </p>
          <p>①姓名</p>
          <p>②移动电话</p>
          <p>③您在网站的表格上输入的其他信息（电子邮箱、车牌号、住址等）</p>
          <p>④在您上传到懂车帝客户端或网站的内容中包含的其他个人信息</p>
          <p>
            2、您需要注意的是，以上个人信息均是您自愿提供。您有权拒绝提供，但如果您不提供相关信息，可能无法注册成为懂车帝的用户或无法享受空间变换公司提供的某些服务，或者无法达到相关服务拟达到的效果。
          </p>
          <p>
            3、对于不满 18
            岁的用户，须在其法定监护人已经阅读本声明并且许可的情况下，通过网站提交个人信息。
          </p>
          <p>二、个人信息的使用和披露</p>
          <br />
          <p>
            1、您同意，我们可以通过以下方式对个人信息进行使用和披露（包含对于个人信息的存储和处理）：
          </p>
          <p>①我们和关联公司使用；</p>
          <p>
            ②我们向相关汽车经销商、厂商及集团分享并由其在合法正当的范围内使用（包括但不限于您主动选择的经销商以及我们为了更好地匹配您的需求，结合您选择的品牌/车型向您推荐的您所在区域同品牌的其他优质经销商）；
          </p>
          <p>
            ③经过您的自主选择，我们可能会与我们的业务合作伙伴（比如二手车平台、汽车融资租赁平台、汽车相关服务及资讯平台）分享并由其在合法正当的范围内使用；
          </p>
          <p>
            ④我们和关联公司、相关汽车经销商、厂商、集团及其他业务合作伙伴为满足您的需求，可能通过您提供的信息与您联系；
          </p>
          <p>
            ⑤我们和关联公司、相关汽车经销商、厂商、集团及其他业务合作伙伴可能定期或不定期向您发送有关产品、服务或相关活动的信息，您同意接收上述信息。
          </p>
          <p>
            如您拟撤回授权/删除您提交的个人信息的，您可以通过“懂车帝”客户端“我的”-“用户反馈”入口与我们联系，我们将尽快配合处理。
          </p>
          <p>
            2、我们将严格保护您的个人信息安全。我们将采用适当制度、安全技术和程序等措施来保护您的个人信息不被未经授权的访问、使用或泄漏。我们亦将促使本法律声明所述各接收和使用方尽力保护和不予泄露您的个人信息。
          </p>
          <p>
            3、您同意免除上述个人信息的接收和/或使用方在按照本法律声明所述情形下进行信息披露和使用而导致的或可能导致的所有索赔、责任和损失。
          </p>
          <p>三、适用法律</p>
          <br />
          <p>1、本声明适用中华人民共和国法律。</p>
          <p>
            2、如果您需要查询、修改或更正您的个人信息，或对个人信息保护问题有任何疑问或投诉，您可以在“用户反馈”中联系我们。
          </p>
          <p>四、变更</p>
          <br />
          <p>
            1、我们会适时对本声明进行修订，该等修订构成本声明的一部分。“空间变换”公司会将修改后的声明予以发布。在该种情况下，若您继续使用我们的服务，即表示同意接受经修订的声明的约束。
          </p>
          <p>
            2、本声明构成《懂车帝隐私政策》的有效组成部分，未尽事宜，以《懂车帝隐私政策》约定为准。
          </p>
        </div>
      </Modal>
      <style jsx>
        {`
          .agree-content {
            max-height: 50vh;
          }

          .btnok {
            font-size: 18px;
            width: 320px;
            height: 40px;
            border-radius: 4px;
            background-color: #ffe100;
            text-align: center;
            line-height: 40px;
            border: none;
            outline: none;
            cursor: pointer;
          }
        `}
      </style>
    </>
  )
}

export default memo(DeclareText)
